import {Booking}  from '../defaultFlow/index.js'
import BookingPriceBreakdownDayTour from './bookingPriceBreakdownDayTour.js'

export default class BookingDayTour extends Booking {
  constructor (options) {
    super(options)
  }

  getBookingPriceBrakedown (options) {
    return new BookingPriceBreakdownDayTour(options).getBookingPriceBreakdown()
  }
}